import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-compare-profile',
    templateUrl: './compare-profile.component.html',
    styleUrls: ['./compare-profile.component.scss'],
    standalone: false
})
export class CompareProfileComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
